import { VoiceListeningGlass } from "@/components/cursors/voice-listening-glass";
import type { ThemeChoice } from "@/lib/theme";

export function IndicatorPreview(props: {
  color: string;
  volume: number;
  camera?: boolean;
  processing?: boolean;
  deadMic?: boolean;
  surface?: "dark" | "light";
  theme?: ThemeChoice;
}) {
  return (
    <VoiceListeningGlass
      color={props.color}
      volume={props.volume}
      status={
        props.deadMic ? "error" : props.processing ? "processing" : "listening"
      }
      camera={props.camera}
      agentName="Denker"
      showAgentName
      surface={props.surface}
      theme={props.theme}
      testId={
        props.deadMic
          ? "voice-indicator-error-glass"
          : props.processing
            ? "voice-indicator-processing-glass"
            : "voice-indicator-listening-glass"
      }
    />
  );
}

export function TintShowcaseCard({
  label,
  ...props
}: {
  label: string;
  color: string;
  volume: number;
  camera?: boolean;
  processing?: boolean;
  deadMic?: boolean;
  surface?: "dark" | "light";
  theme?: ThemeChoice;
}) {
  return (
    <div className="min-h-[132px] rounded-xl border border-white/[0.08] bg-black/20 p-4">
      <div className="mb-5 text-xs text-white/45">{label}</div>
      <div className="flex h-16 items-center justify-center">
        <VoiceListeningGlass
          color={props.color}
          volume={props.volume}
          status={
            props.deadMic
              ? "error"
              : props.processing
                ? "processing"
                : "listening"
          }
          camera={props.camera}
          agentName="Denker"
          showAgentName
          surface={props.surface}
          theme={props.theme}
          testId={`voice-showcase-${label.toLowerCase().replace(/\s+/g, "-")}`}
        />
      </div>
    </div>
  );
}
